import React from 'react';
import { Wizard } from 'react-use-wizard';
import StartTrialStep from './StartTrialStep';
import StartTrialStatusStep from './StartTrialStatusStep';
import T from 'prop-types';
import { noop } from 'lodash';
var StartTrialWizard = function(param) {
    var onCancel = param.onCancel, onStartTrial = param.onStartTrial, isHighResClicked = param.isHighResClicked, _param_callback = param.callback, callback = _param_callback === void 0 ? noop : _param_callback;
    return /*#__PURE__*/ React.createElement(Wizard, null, /*#__PURE__*/ React.createElement(StartTrialStep, {
        onCancel: onCancel,
        isHighResClicked: isHighResClicked
    }), /*#__PURE__*/ React.createElement(StartTrialStatusStep, {
        onNext: onStartTrial !== null && onStartTrial !== void 0 ? onStartTrial : onCancel,
        callback: callback
    }));
};
StartTrialWizard.propTypes = {
    onCancel: T.func,
    onStartTrial: T.func,
    isHighResClicked: T.bool,
    callback: T.func
};
export default StartTrialWizard;
